// **用户接口列表**

import base from '../base.js'; // 导入接口域名列表
import axios from '../http.js'; // 导入http中创建的axios实例

const user = {
    // 用户登陆
    login (params) {
        return axios.post(`${base.bds}/user/authorizations/`, params)
    },
    // 获取用户信息
    userInfo () {
        return axios.get(`${base.bds}/user/info/`)
    },
    // 退出登陆
    logOut() {
        return axios.get(`${base.bds}/user/logout/`)
    },
    // 检测用户账号是否被注册
    monitorUserName(username) {
        return axios.get(`${base.bds}/user/users/usernames/${username}/count`)
    },
    // 检测用户手机号是否被注册
    monitorMobile(mobile) {
        return axios.get(`${base.bds}/user/users/mobiles/${mobile}/count`)
    },
    // 给手机号发送验证码
    sendCode(params) {
        return axios.post(`${base.bds}/user/users/sms_codes/`, params)
    },
    // 用户注册
    register(params) {
        return axios.post(`${base.bds}/user/users/`, params)
    },
    // =======================关注============================
    // 我的关注文件夹列表
    filesList(params) {
        return axios.get(`${base.bds}/user/follow/tags/`, {
            params: params
        });
    },
    // 弹窗文件夹列表
    filesListItem(params) {
        return axios.get(`${base.bds}/user/follow/groupauthor/`, {
            params: params
        });
    },
    // 新增文件夹
    addFiles(params) {
        return axios.post(`${base.bds}/user/follow/tags/`, params);
    },
    // 编辑文件夹
    editFiles(params) {
        return axios.put(`${base.bds}/user/follow/tags/`, params);
    },
    // 删除文件夹
    deleteFiles(params) {
        return axios.delete(`${base.bds}/user/follow/tags/`, {
            data: params
        });
    },
    // 我的关注列表
    followList(params) {
        return axios.get(`${base.bds}/dy/follerauthor/`, {
            params: params
        });
    },
    // 我的关注列表(基本数据)
    janeFollowList(params) {
        return axios.get(`${base.bds}/dy/getfollerauthor/`, {
            params: params
        });
    },
    // 我的关注列表总数
    followListAll(params) {
        return axios.get(`${base.bds}/dy/follerauthorall/`, {
            params: params
        });
    },
    // 取消关注
    cancelFollow(params) {
        return axios.delete(`${base.bds}/user/follow/groupauthor/`, {
            params: params
        });
    },
    // 复制主播到收藏夹列表
    copyFilesList(params) {
        return axios.get(`${base.bds}/user/follow/group/copy/`, {
            params: params
        });
    },
    // 复制到对应收藏夹
    copyFollow(params) {
        return axios.post(`${base.bds}/user/follow/group/copy/`, params);
    },
    // 移动主播到收藏夹列表
    moveFilesList(params) {
        return axios.get(`${base.bds}/user/follow/group/move/`, {
            params: params
        });
    },
    // 移动到对应收藏夹
    moveFollow(params) {
        return axios.post(`${base.bds}/user/follow/group/move/`, params);
    },
    // 关注主播
    follow(params) {
        return axios.post(`${base.bds}/user/follow/groupauthor/`, params);
    },
    // 获取账号使用情况
    getUsage() {
        return axios.get(`${base.bds}/user/userquota/`);
    },
    // 获取清空次数
    getClear() {
        return axios.get(`${base.bds}/user/follow/clean/`);
    },
    // 清空关注
    clearFollow() {
        return axios.post(`${base.bds}/user/follow/clean/`);
    },
    // 修改密码
    updatePassword(params) {
        return axios.put(`${base.bds}/user/modification/`, params);
    },
    // 兑换会员
    exchange(params) {
        return axios.post(`${base.bds}/voucher/redeem/`, params);
    },
    // 授权列表
    grantList(params) {
        return axios.get(`${base.bds}/oauth/creator_auth_list/`, {
            params: params
        });
    },
    // 关注账号直播间对比
    getCompaialfollowroom(params) {
        return axios.post(`${base.bds}/dy/comparefollowmultiroom/`, params);
    }
}

export default user;



// WEBPACK FOOTER //
// ./src/utils/api/user.js